module.exports = __webpack_public_path__ + "static/img/guenon.b574efc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/amenities/tables/guenon.jpg
// module id = 635
// module chunks = 0